import React from "react";
import { Radio } from "@c4c-web/ui";
import { AddressListItem } from "./AddressListItem";
import { type IAddressListProps } from "./address-list.interface";
import { getAddressOptionInfo } from "./address-list.helpers";
import {
  AddressBadge,
  AddressLabelWithEditIcon,
  UnverifiedAddressMessage,
} from "./AddressListComponents";

export const AddressList: React.FC<IAddressListProps> = ({
  options,
  selectedValue,
  closeDrawer,
  onSelect,
  onUpdateUnverifiedAddress,
  t,
}): JSX.Element => {
  return (
    <div className="flex w-full flex-col gap-md md:h-full">
      {options.map((option) => {
        const { label, value, status, badgeColor, badgeTitle } =
          getAddressOptionInfo(option, selectedValue, t);

        const addressLabel = (
          <AddressLabelWithEditIcon
            label={label}
            onUpdateUnverifiedAddress={onUpdateUnverifiedAddress}
            status={status}
            value={value}
          />
        );

        return (
          <div className="flex flex-col gap-xs" key={value}>
            <AddressListItem
              closeDrawer={closeDrawer}
              onSelect={onSelect}
              selectedValue={selectedValue}
              status={status}
              value={value}
            >
              <Radio
                isChecked={selectedValue === value}
                label={addressLabel}
                labelClassname="w-full"
                onValueChange={onSelect as unknown as () => void}
                value={value}
              />
              <AddressBadge badgeColor={badgeColor} badgeTitle={badgeTitle} />
            </AddressListItem>

            <UnverifiedAddressMessage status={status} t={t} />
          </div>
        );
      })}
    </div>
  );
};
